module.exports = __webpack_public_path__ + "static/img/widgets_mob.153864c3.png";